<div class="content">
    <h1>{{ 'Prices' | i18n }}</h1>

    <h4>{{ 'So how much does it cost?' | i18n }}</h4>
    <div>
        {{ 'You can choose between' | i18n }}
        <b>{{ 'Subscription' | i18n }}</b>
        {{ 'or' | i18n }}
        <b>{{ 'TopUp' | i18n }}</b>
    </div>
    
    <p>
        <h2 value=" topUp">{{'Subscription'|i18n}}</h2>
    <!-- <div>
            {{'Current Token Type'|i18n}}: <b>{{tokenType | i18n}}</b>
        </div> -->
    <div>
        {{'Monthly Subscription Price'|i18n}} <b>200</b> {{'$'|i18n}}
        <ul>
            <li> {{'Parse Invoice'|i18n}} <b>0.05</b> {{'$'|i18n}} </li>
            <li> {{'Other Documents'|i18n}} <b>0.50</b> {{'$'|i18n}} </li>
        </ul>
        <div><b>* {{'Note: If the API is not in use, there will be no monthly fee.'| i18n}}</b></div>
    </div>
    <h2 value="topUp">{{'TopUp'|i18n}}</h2>

    <div>
        {{'Monthly Subscription Price'|i18n}} <b>0</b> {{'$'|i18n}}
        <ul>
            <li> {{'Parse Invoice'|i18n}} <b>0.10</b> {{'$'|i18n}} </li>
            <li> {{'Other Documents'|i18n}} <b>1.00</b> {{'$'|i18n}} </li>
        </ul>
    </div>
    <p>
        <a class="btn btn-success" routerLink="/user" routerLinkActive="active" role="button">
            {{"Create a free account, no commitments or hidden fees."|i18n}}
        </a>

    </p>
    <p>

    </p>
</div>